import type { RiskType } from "@screener/contracts";

/**
 * 통합 지점 I-04 / I-03.
 * 스크리너에서 낙찰로드(학습·체크리스트)로 넘어가는 링크를 한곳에서 만든다.
 * 두 앱은 같은 도메인에 있고 낙찰로드는 /study 아래에 붙는다.
 * 코드를 서로 import 하지 않고 URL 로만 결합한다.
 */

export const STUDY_BASE = "/study" as const;

/** 위험 유형별로 먼저 읽어야 할 학습 스테이지 */
export const RISK_TO_STAGE: Record<RiskType, string> = {
  seizure: "rights-extinction",
  lien: "hard-filter",
  share_sale: "hard-filter",
  statutory_superficies: "hard-filter",
  senior_provisional_registration: "rights-order",
  senior_injunction: "rights-order",
  resale: "hard-filter",
  tenant_opposing_power: "tenant-opposing-power",
  tax_arrears: "distribution-order",
};

export function studyStageUrl(riskType: RiskType): string {
  return `${STUDY_BASE}/stage/${RISK_TO_STAGE[riskType]}`;
}

export interface ChecklistSeed {
  /** 사건번호 + 물건명. 낙찰로드 체크리스트의 라벨이 된다. */
  label: string;
  court?: string | null;
  /** YYYY-MM-DD */
  saleDate?: string | null;
  /** 스크리너 물건 id — 나중에 되짚어 올 수 있게 넘긴다. */
  propertyId?: string | null;
}

/**
 * 낙찰로드의 '새 물건 만들기' 화면을 미리 채워서 연다.
 * 낙찰로드 쪽은 이 query 를 초기값으로 읽기만 하면 된다 (I-03).
 */
export function checklistNewUrl(seed: ChecklistSeed): string {
  const p = new URLSearchParams();
  p.set("label", seed.label);
  if (seed.court) p.set("court", seed.court);
  if (seed.saleDate) p.set("saleDate", seed.saleDate);
  if (seed.propertyId) p.set("propertyId", seed.propertyId);
  return `${STUDY_BASE}/checklist/new?${p.toString()}`;
}
